// 报表管理路由
 
const StatementMana = [
    // 用量报表
    {
        path: '/usestatement',
        component: resolve => require(['@/views/StatementMana/UseStatement/UseStatement'], resolve),
        name: 'residentDosage',
        meta: { title: '用量报表', breadcrumb: [{ menu: 'residentDosage' }], role: 'report' }
    },
    // 应收报表
    {
        path: '/receivablestatement',
        component: resolve => require(['@/views/StatementMana/ReceivableStatement/ReceivableStatement'], resolve),
        name: 'receivablestatement',
        meta: { title: '应收报表',  breadcrumb: [{ menu: 'receivablestatement' }], role: 'report' }
    },
    // 缴费报表
    {
        path: '/paystatement',
        component: resolve => require(['@/views/StatementMana/PayStatement/PayStatement'], resolve),
        name: 'paystatement',
        meta: { title: '缴费报表', breadcrumb: [{ menu: 'paystatement' }], role: 'report' }
    },
	// 表计历史数据
	{
	    path: '/historyreport/:oid',
	    component: resolve => require(['@/views/StatementMana/HistoryReport/historyreport'], resolve),
	    name: 'historyreport',
	    meta: { title: '表计历史数据', breadcrumb: [{ menu: 'historyreport' }], role: 'report' }
	},
];

export default StatementMana